var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "submission-request-edit", attrs: { id: _vm.id } },
    [
      _c("p", { staticClass: "hint" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("project.submission.title")) + "\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "submission-request-info" }, [
        _c("div", { staticClass: "sr-completion-type" }, [
          !_vm.isWorkCompleted
            ? _c("div", { staticClass: "row completion-type" }, [
                _c("input", {
                  directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                  staticClass: "final-partial-checkbox",
                  attrs: {
                    id: "sr-completionType-final-partial-" + _vm.id,
                    type: "checkbox",
                  },
                  domProps: { checked: _vm.finalPartial },
                  on: {
                    change: function (event) {
                      return _vm.setFinalPartialCompletionType(event)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "final-completion",
                    attrs: { for: "sr-completionType-final-partial-" + _vm.id },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("project.submission.workComplete")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("label", { staticClass: "hint work-complete-hint" }, [
                  _vm._v(_vm._s(_vm.workCompleteHintMsg)),
                ]),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isDraftRetentionSubmission,
                expression: "isDraftRetentionSubmission",
              },
            ],
            staticClass: "row completion-type",
          },
          [
            _c("label", { staticClass: "retention-completion" }, [
              _vm._v(_vm._s(_vm.retentionCompletionTypeView)),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sr-completion-date" },
          [
            _c("label", { staticClass: "required-flag" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("project.submission.completedOn")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("DatePicker", {
              class: _vm.errCompletedDateClass,
              attrs: {
                id: "sr-completed-date-" + _vm.id,
                format: "DD MMM YY",
                disabled: _vm.disabledDates,
                disabledPicker: !_vm.canContractorEdit,
                calendarButton: true,
                calendarButtonIcon: "fa fa-calendar",
              },
              model: {
                value: _vm.completedDate,
                callback: function ($$v) {
                  _vm.completedDate = $$v
                },
                expression: "completedDate",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sr-service-received clearfix" },
          [
            _c("TextField", {
              directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
              attrs: {
                label: _vm.requestLabel,
                required: "",
                value: _vm.submission.completedItems,
                readonlyAsInput: !_vm.canContractorEdit,
                hintBeforeInput: _vm.$t("hint.anyDeduction"),
                hintClass: "hint sr-service-received-hint",
                inputTip: "tooltip-class",
              },
              on: {
                updateValue: function (val) {
                  return _vm.updateFieldValue(val, "completedItems")
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _vm.showInvoiceModule
              ? _c("InvoiceInfo", {
                  attrs: {
                    submission: _vm.submission,
                    srIndex: _vm.srIndex,
                    highlightInvalidAmount: _vm.highlightCompletedAmount,
                    highlightInvoiceNo: _vm.highlightInvoiceNo,
                    canEdit: _vm.canContractorEdit,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("PaidStatus", {
              attrs: {
                submission: _vm.submission,
                isContractor: _vm.isContractor,
                isEdit: _vm.isEdit,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("po-balance-calculation", {
              attrs: {
                submission: _vm.submission,
                srIndex: _vm.srIndex,
                highlightInvalid: _vm.highlightCompletedAmount,
              },
              on: {
                "clear:errorHighlight": function () {
                  return (_vm.highlightCompletedAmount = false)
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.showInvoiceModule
          ? _c(
              "div",
              {
                staticClass: "project-sr--invoice-attachment",
                class: { "error-highlight": _vm.highlightInvoiceDoc },
              },
              [
                _c("div", [
                  _c("label", { staticClass: "required-flag" }, [
                    _vm._v(_vm._s(_vm.$t("project.submission.invoice"))),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "hint" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("hint.regionConfig.limitImg")) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.canContractorEdit
                  ? _c("HkldDropzone", {
                      attrs: {
                        maxNumberOfFiles: 1,
                        uploadDocTypes: ".pdf,.png,.jpg,.jpeg",
                        sourceId: (_vm.submission.invoice || {}).id || "",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("EditAttachments", {
                  ref: "invoiceAttachment",
                  attrs: {
                    sourceId: (_vm.submission.invoice || {}).id || "",
                    canEdit: _vm.canContractorEdit,
                    uploadSuccessCb: _vm.removeOldDocNClearHighlight,
                    getFilesList: _vm.getInvoiceFileList,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "project-sr-attachment clearfix" },
          [
            _c("div", [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("project.submission.supportDocs"))),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "hint" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("hint.attachmentTips")) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.canContractorEdit
              ? _c("HkldDropzone", { attrs: { sourceId: _vm.submission.id } })
              : _vm._e(),
            _vm._v(" "),
            _c("EditAttachments", {
              attrs: {
                sourceId: _vm.submission.id,
                canEdit: _vm.canContractorEdit,
                canDelete: _vm.canContractorEdit,
                canDownloadAll: !_vm.canContractorEdit,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row person-in-charge" }, [
          _c(
            "div",
            { staticClass: "small-3 medium-3 large-3 columns" },
            [
              _c("TextField", {
                attrs: {
                  label: _vm.$t("PIC"),
                  value: _vm.personInCharge,
                  readonlyAsInput: !_vm.canContractorEdit,
                  required: "",
                },
                on: {
                  updateValue: function (val) {
                    return _vm.updateFieldValue(val, "personInCharge", "name")
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "small-4 medium-4 large-4 columns" },
            [
              _c("TextField", {
                attrs: {
                  label: _vm.$t("position"),
                  value: _vm.position,
                  readonlyAsInput: !_vm.canContractorEdit,
                  required: "",
                },
                on: {
                  updateValue: function (val) {
                    return _vm.updateFieldValue(
                      val,
                      "personInCharge",
                      "position"
                    )
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "small-5 medium-5 large-5 columns" },
            [
              _c("TextField", {
                attrs: {
                  label: _vm.$t("onBehalfOf"),
                  value: _vm.companyName,
                  readonly: true,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.rejectHistory && _vm.rejectHistory.length > 0,
              expression: "rejectHistory && rejectHistory.length > 0",
            },
          ],
          staticClass: "action-history",
        },
        [
          _c("div", [_c("label", [_vm._v(_vm._s(_vm.$t("history")))])]),
          _vm._v(" "),
          _vm._l(_vm.rejectHistory, function (history, index) {
            return _c("reject-history", {
              key: index,
              class: { "odd-row": index % 2 },
              attrs: {
                item: history,
                isContractor: _vm.isContractor,
                showRejectHeader: !index,
              },
            })
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sr-actions" },
        [
          _c("HKLButton", {
            attrs: { action: "save", color: "orange" },
            on: {
              click: function () {
                return _vm.save()
              },
            },
          }),
          _vm._v(" "),
          _c("HKLButton", {
            class: { "btn--disabled": _vm.disableSubmit },
            attrs: { action: "submit", color: "orange" },
            on: {
              click: function () {
                return _vm.submit()
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "confirmBalanceModal",
        attrs: {
          modalId: _vm.confirmBalanceModalId,
          confirmBtnName: _vm.$t("action.yesSubmit"),
          confirmTitle: _vm.$t(
            "project.submission.remaingBalanceWorkCompletedHint"
          ),
        },
      }),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "projectSrSubmitModal",
          attrs: { modalId: "project-sr-submit-modal", showCloseBtn: true },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("p", { staticClass: "modal-pure-text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("hint.uploadRequiredDocs")) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange close-reveal-modal",
                attrs: { type: "button" },
                on: {
                  click: function () {
                    return _vm.closeSubmitModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.ok")))]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "projectSrRefreshModal",
          attrs: { modalId: "project-sr-refresh-modal" },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("p", { staticClass: "modal-pure-text" }, [
              _vm._v("\n        " + _vm._s(_vm.refreshModalHint) + "\n      "),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue close-reveal-modal",
                attrs: { type: "button" },
                on: {
                  click: function () {
                    return _vm.closeRefreshSubmissionModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.ok")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }